import React from "react";
import { Link } from "react-router-dom";

const FollowedCreatorCard = ({ creator }) => (
  <Link
    to={`/fan/creator/${creator.username}`}
    className="flex items-center p-4 bg-white rounded-xl border border-slate-200"
  >
    <img
      src={creator.profilePictureUrl}
      alt={creator.name}
      className="w-12 h-12 rounded-full object-cover mr-4"
    />
    <div>
      <p className="font-semibold text-slate-800">{creator.name}</p>
      <p className="text-sm text-slate-500">@{creator.username}</p>
    </div>
  </Link>
);

export default FollowedCreatorCard;
